import { $thm } from '~/common/themeSx'
import { Box, ContainerProps, useTheme } from '../../chakra'

/**
 * A Box that centers your content with a maxWidth of 1500px
 *
 * See: https://storybook.beta.vndly.com/?path=/docs/components-container--docs
 *
 * @agent-gotcha Default px is `$thm`: legacy `{ base: 6, lg: 12 }`, rebrand flat `6`. Pass consumer `px` in sx. Style props lose to `[data-canvas-theme] &`.
 * @agent-gotcha Nested containers stay `px: 0`.
 */
export const Container = ({ sx, px, ...props }: ContainerProps) => {
  const theme = useTheme()
  return (
    <Box
      data-ds-container
      sx={{
        ...$thm({
          // Dual gutter while sana_rebrand_enabled exists. After the flag dies:
          // default `px={6}`, then `{...props}` so consumers still win.
          px: { base: 6, lg: 12, $canvas: 6 },
          '[data-ds-container] &': {
            // Both halves must be 0. A plain `px: 0` loses to the canvas gutter hoist.
            px: { $base: 0, $canvas: 0 }
          }
        }),
        // Style props lose to `[data-canvas-theme] &`. After the flag dies, pass
        // `px` as a style prop before `{...props}` and delete this branch.
        ...(px !== undefined
          ? {
              px,
              '[data-canvas-theme] &': { px }
            }
          : null),
        ...sx
      }}
      {...props}
      mx="auto"
      w="full"
      maxW={theme.breakpoints.xl}
    />
  )
}
